// Who speaks what in the room, and whether translation is on: the status line in the header.
// Pure, over the participants' names and vm.lang attributes.

export interface Speaker {
  readonly identity: string;
  readonly name: string;
  /** The participant's vm.lang (a code from languages.ts, or whatever was sent). */
  readonly language: string;
  readonly isLocal: boolean;
}

export type TranslationState =
  /** Nobody else is in the room yet. */
  | 'alone'
  /** Everyone speaks the same language: nothing to translate. */
  | 'off'
  /** At least two languages: the interpreter translates between them. */
  | 'on';

export interface LanguageStatus {
  readonly speakers: readonly Speaker[];
  readonly languages: readonly string[];
  readonly translation: TranslationState;
}

/** The speakers in the order given, the languages they speak (in order of first appearance), and the state. */
export function languageStatus(speakers: readonly Speaker[]): LanguageStatus {
  const languages: string[] = [];
  for (const speaker of speakers) {
    if (speaker.language && !languages.includes(speaker.language)) languages.push(speaker.language);
  }
  const translation: TranslationState = speakers.length < 2 ? 'alone' : languages.length > 1 ? 'on' : 'off';
  return { speakers, languages, translation };
}
